var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipmentAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3726_21487)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5095 9.99502L19.4585 8.23992C19.8032 8.08669 20.1968 8.08669 20.5415 8.23992L31.2082 12.9807C31.6897 13.1947 32 13.6722 32 14.1991V27.1327C32 27.6597 31.6897 28.1372 31.2082 28.3512L20.5415 33.0919C20.1968 33.2451 19.8032 33.2451 19.4585 33.0919L8.79182 28.3512C8.31031 28.1372 8 27.6597 8 27.1327V14.1991C8 13.6722 8.31031 13.1947 8.79182 12.9807L12.2095 11.4617L24.8235 16.7175C25.0719 16.821 25.2338 17.0637 25.2338 17.3329V22.2039C25.2338 22.6865 25.7306 23.0092 26.1715 22.813L27.6044 22.1753C27.8449 22.0682 28 21.8296 28 21.5662V15.7727C28 15.5057 27.8407 15.2645 27.5953 15.1596L15.5095 9.99502Z",
    fill: "#0A2432"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3726_21487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentAdd);
export default __webpack_public_path__ + "static/media/shipment_add.1be5a2b55aa0408cb1008dcc0ac40c1f.svg";
export { ForwardRef as ReactComponent };